import React, { useEffect, useState } from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

interface SvgIconBaseProps extends SvgIconProps {
  src: string;
}

const SvgIconBase: React.FC<SvgIconBaseProps> = ({ src, ...props }) => {
  const [svgContent, setSvgContent] = useState<string>('');
  const [viewBox, setViewBox] = useState<string>('0 0 24 24');

  useEffect(() => {
    fetch(src)
      .then((res) => res.text())
      .then((text) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'image/svg+xml');
        const svgEl = doc.querySelector('svg');

        if (svgEl) {
          const parsedViewBox = svgEl.getAttribute('viewBox');
          if (parsedViewBox) setViewBox(parsedViewBox);
          setSvgContent(svgEl.innerHTML);
        }
      })
      .catch(() => setSvgContent(''));
  }, [src]);

  return (
    <SvgIcon viewBox={viewBox} {...props}>
      <g dangerouslySetInnerHTML={{ __html: svgContent }} />
    </SvgIcon>
  );
};

export default SvgIconBase;
